import axios from "axios";
import { addGeoParam, getLanguageCode } from "../../utils/getURLParams";
import { getDomainConfig } from "../../config/config";
import API from "../../api/phx";
import Cookies from "js-cookie";
import { markOrderPaymentStatusFailed } from "../../utils/markPaymentAsFailed";
import { getEnv } from "../../utils/getEnv";
import ExitPopUp from '../../utils/exitPopUp';

export const googlePayConfiguration = () => {
  const publicKey = PublicKey.GetPublicKey();
  return {
    apiVersion: 2,
    apiVersionMinor: 0,
    allowedPaymentMethods: [
      {
        type: "CARD",
        tokenizationSpecification: {
          type: "PAYMENT_GATEWAY",
          parameters: {
            gateway: "checkoutltd",
            gatewayMerchantId: publicKey,
          },
        },
        parameters: {
          allowedCardNetworks: ["VISA", "AMEX", "MASTERCARD"],
          allowedAuthMethods: ["PAN_ONLY", "CRYPTOGRAM_3DS"],
        },
      },
    ],
  };
};

export const googlePay = (amountToPay, currency, countryCode, googlePayClient) => {

  const config = getDomainConfig();
  const paymentDataRequest = { ...googlePayConfiguration()};
  paymentDataRequest.merchantInfo = {
      merchantId: getEnv() === 'live' ? "BCR2DN4TZLD3TVLM" : "merchantId",
      merchantName: config.externalPayLabel,
    };

  paymentDataRequest.transactionInfo = {
      totalPriceStatus: "FINAL",
      totalPrice: amountToPay.toFixed(),
      currencyCode: currency,
      countryCode: countryCode,
    };

    return googlePayClient.loadPaymentData(paymentDataRequest)
};

export class Gpay {
  static googleClient;

  static SetGoogleClient(GoogleClient){
    this.googleClient = GoogleClient;
  }

  static GetGoogleClient(){
    return this.googleClient;
  }
}

export class PublicKey {
  static publicKey;

  static SetPublicKey(key) {
    this.publicKey = key;
  }

  static GetPublicKey() {
    return this.publicKey;
  }
}

export class ThreeDSRedirectURL {
  static threeDSURL;

  static SetThreeDSURL(URL) {
    this.threeDSURL = URL;
  };

  static GetThreeDSURL() {
    return this.threeDSURL;
  };
};

export const processPaymentData = (paymentData, orderContext, amountToPay, currency, countryCode, orderId, showFormFunc, showPayWithMessageFunc, setOpenModal, setOrder, setOrderCreationStatus, setShouldShow3ds) => {
  const domainConfig = getDomainConfig();
  const complete = (domainConfig.brand === "Atd") ? 'incomplete' : 'complete';

  const BACKEND_URL_PAY = `https://${window.location.hostname}/api/payments/checkoutdotcom/google-pay?action=googlepay&cached=0${domainConfig.brand === 'Atd' ? '&geo=' + addGeoParam() : ''}`;

  let details;
  orderContext.amountToPay = (amountToPay * 100).toFixed();
  orderContext.currency = currency;
  orderContext.countryCode = countryCode;
  orderContext.order_id = orderId;
  details = { orderData: orderContext };

  const parsedToken = JSON.parse(paymentData.paymentMethodData.tokenizationData.token);

  details.token = { paymentData: parsedToken };

  axios.post(
    BACKEND_URL_PAY,
    {
      details,
    },
    {
      headers: { "Access-Control-Allow-Origin": "*" },
    }
  ).then(({ data }) => {
      if (data && ("_links" in data) && ("3ds" in data) && ("redirect" in data._links)) {
          ThreeDSRedirectURL.SetThreeDSURL(data._links.redirect.href)
          setShouldShow3ds(true);
      } else if (data && data.approved && !("3ds" in data) &&  (data.status === "Authorized") && (data.responseMessage === "Approved")) {
        setOrderCreationStatus("finalizing");
        if (!data.risk.flagged) {
          API.delete("/cart").then(() => {
            Cookies.set("orderDoComplete",true);
            Cookies.set("risk",false);
            Cookies.set("flagged",false);
            Cookies.set("display",true);

            ExitPopUp.Disable();
            window.location.href = `${getLanguageCode(
              domainConfig.brand,
              true
            )}/cart/checkout/complete/${orderId}`;
          });
        } else if (data.risk.flagged) {
          API.delete("/cart").then(() => {
              Cookies.set('orderDoComplete',false);
              Cookies.set('flagged',true);
              Cookies.set('display',false);

              ExitPopUp.Disable();
              window.location.href = `${getLanguageCode(
                domainConfig.brand,
                true
              )}/cart/checkout/${complete}/${orderId}`;
          });
        }
      } else if (data && !data.approved && (data.status === 'Declined')) {
        setOrderCreationStatus("finalizing");
        markOrderPaymentStatusFailed(orderId, false, 'Google Pay').then(() => {
          API.delete("/cart").then(() => {
            Cookies.set('orderDoComplete',false);
            Cookies.set('flagged',false);
            Cookies.set('display',false);
            ExitPopUp.Disable();
            window.location.href = `${getLanguageCode(
              domainConfig.brand,
              true
            )}/cart/checkout/${complete}/${orderId}`;
          });
        })
      } else {
        setOrderCreationStatus("finalizing");
        setOpenModal(false);
        setOrder({});
        markOrderPaymentStatusFailed(orderId, false, 'Google Pay');
        showFormFunc();
        showPayWithMessageFunc(false);
      }
  });
};